// Marca que o coletor foi aberto pelo CTA, para mostrar o atalho de volta so nesse caso.
// Fica na sessao da aba porque as telas internas do coletor navegam sem levar estado.
const KEY = "floraiq_coletor_from_cta";

export function markCameFromCta(): void {
  try { sessionStorage.setItem(KEY, "1"); } catch { /* sem armazenamento: so nao mostra o atalho */ }
}

export function cameFromCta(): boolean {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function clearCameFromCta(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* idem */ }
}
